import { useEffect, useRef } from "react";
import i18next from "i18next";
import { Profile } from "@/models/database/profiles/profile.model";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { Box, Tabs } from "@radix-ui/themes";

export default function ProfileTabs({
  belongToCurrentUser,
  setCurrentTab,
  currentTab,
  currentUserProfile,
  slug,
  loading,
}: {
  slug: string;
  belongToCurrentUser: boolean;
  currentTab: FeedType;
  setCurrentTab: React.Dispatch<React.SetStateAction<FeedType>>;
  currentUserProfile: Profile;
  loading: boolean;
}) {
  const handleTabClick = (tab: FeedType) => {
    setCurrentTab(tab);
  };
  const tabsRef = useRef<any>({});

  const getProfileTabs = (
    belongsToCurrentUser: boolean
  ): { [key: string]: String | undefined } =>
    belongsToCurrentUser
      ? {
          posts: brand.hasFeature.posts ? "Feed" : undefined,
          challenges: brand.hasFeature.challenges ? "challenges" : undefined,
          teams: brand.hasFeature.teams ? "teams" : undefined,
          achievements: brand.hasFeature.achievements
            ? "achievements"
            : undefined,
        }
      : {
          posts: brand.hasFeature.posts ? "Feed" : undefined,
        };

  useEffect(() => {
    const savedTab = localStorage.getItem("activeTab");
    const profileTabs = getProfileTabs(belongToCurrentUser);
    if (savedTab && profileTabs[savedTab]) {
      setCurrentTab(savedTab as FeedType);
    } else {
      if (brand.hasFeature.posts) {
        setCurrentTab("posts");
      } else {
        setCurrentTab("challenges");
      }
    }
  }, [slug, currentUserProfile?.slug, currentUserProfile?.uid]);

  return (
    <>
      {/* If screen width is bigger than 576px the tabs appear on the left panel */}
      <Tabs.List>
        {Object.keys(getProfileTabs(belongToCurrentUser)).map((key, index) => {
          if (
            Object.values(getProfileTabs(belongToCurrentUser))[index] !==
            undefined
          ) {
            return (
              <Tabs.Trigger key={key} value={key}>
                <Box onClick={() => handleTabClick(key as FeedType)}>
                  {i18next.t(`profile.tabs.${key}`)}
                </Box>
              </Tabs.Trigger>
            );
          }
        })}
      </Tabs.List>
    </>
  );
}
